/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type PmTaskPriority = typeof PmTaskPriority[keyof typeof PmTaskPriority];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PmTaskPriority = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
} as const;
